export default __webpack_public_path__ + "static/minglanilla-cebu-f6f8b9ab3754aeedd6f0a9afe4d5ccbf.jpg";